import { registerComponent } from '@gig/magic-common';
import StaticPageContentComponent from './static-page-content.vue.js';

var StaticPageContent = registerComponent(StaticPageContentComponent);

export { StaticPageContent };
